<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tit.reportGenerated.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.master')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/master/reportGenerated"><span>{{$t('tlt.reports')}}</span></router-link></li>
                </ul>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.code") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="codeFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.name") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="locNameFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.type") }} :
                                    </label>
                                    <select class="form-control" v-model="locTypeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="E">{{ $t("lbl.reportGenerated.enterprise") }}</option>
                                        <option value="S">{{ $t("lbl.reportGenerated.site") }}</option>
                                        <option value="A">{{ $t("lbl.basic.area") }}</option>
                                        <option value="W">{{ $t("lbl.reportGenerated.workCenter") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.active") }}:
                                    </label>
                                    <select class="form-control"  v-model="activeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                </div>
                                <div class="col-lg-2 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('reportGenerated')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="loadRowsReport()">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="reportGeneratedResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <div class="bs-component">
                                <div class="btn-group float-left">
                                    <a href="#" data-toggle="modal" class="btn btn-outline-primary btn-sm"
                                    v-on:click="MMFDelete('reportGenerated')">
                                        <i title="lbl.basic.delete" class="fa fa-trash"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="float-lg-right">
                                    <a href="#" class="btn btn-outline-primary" title="export">
                                        <i class="fa fa-file-export"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="clearfix">&nbsp;</div>
                            <b-table
                                striped
                                hover
                                responsive
                                caption-top
                                :items="rows"
                                :fields="tableColumns">

                                <template slot="table-caption">
                                    <b-form-checkbox @click.native.stop @change="MMFselectAllRows()">
                                        Select all
                                    </b-form-checkbox>
                                </template>
                                <template slot="state" slot-scope="data">
                                    <b-form-checkbox @click.native.stop @change="MMFselectRow({item: data.item, entity:'reportGenerated'})">
                                    </b-form-checkbox>
                                </template>
                                <template slot="download" slot-scope="item">
                                    <a :href="item.item.downloadLink">
                                        <i class="fas fa-file-download fa-2x"/>
                                    </a>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/master/ReportGenerated";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'reportGenerated/getField',
    mutationType: 'reportGenerated/updateField',
  });

export default {
  name: "reportGeneratedList",
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.reportGenerated.rows,
            tableColumns: gridFields
        })
  },
  methods: {
      ...mapActions("reportGenerated", ["loadRowsReport"]),
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows",  
    "MMFDelete", "MMFClearFilter"])
  }
};
</script>
